const divModalEquipCheckList = {
  groupQuestionArray: 'Checklist sem nenhuma pergunta adicionada'
};

export default divModalEquipCheckList;
